// extracted by mini-css-extract-plugin
export default {"clUserLinks":"recyclingMenu_clUserLinks__U1piM"};